import { Box, Typography, Grid } from "@mui/material";
import hamburguesa from "../../../images/promos/hamburguesa.png";
import combustible from "../../../images/promos/combustible.png";
import ahorro1 from "../../../images/promos/ahorro1.png";
import ahorro2 from "../../../images/promos/ahorro2.png";
import full from "../../../images/fullSinFondo.svg";
import patagoniaplus from "../../../images/patagoniaplus.png";
import React, { useState, useRef, useEffect } from "react";
import tienda from "../../../images/tienda.svg";

export const Promociones = () => {
  const isYPF = localStorage.getItem("bandera") === "ypf";
  const [currentVariant, setCurrentVariant] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [slideDirection, setSlideDirection] = useState('');
  const touchStartRef = useRef(null);
  const touchEndRef = useRef(null);

  // Configuración de las variantes
  const variants = [
    {
      day: "Martes",
      mainImage: hamburguesa,
      mainImageAlt: "Hamburguesa",
      promoImage: ahorro1,
      promoImageAlt: "Ahorro 1",
      logoImage: isYPF ? full : tienda,
      logoImageAlt: isYPF ? "Full" : "Tienda",
      promoText: `EN COMBOS ${isYPF ? "FULL" : "TIENDA"}`,
      color: "#C5B198",
      ml: "25rem",
      widthImg: "60%",
      widthLogo: isYPF ? "15%" : "30%",
    },
    {
      day: "Jueves",
      mainImage: combustible,
      mainImageAlt: "Combustible",
      promoImage: ahorro2,
      promoImageAlt: "Ahorro 2",
      logoImage: patagoniaplus,
      logoImageAlt: "Patagonia Plus",
      promoText: `EN COMBUSTIBLES, LUBRICANTES Y ${isYPF ? "FULL" : "TIENDA"}`,
      color: "#213157",
      ml: "5rem",
      widthImg: "50%",
      widthLogo: "40%",
    },
  ];

  // Función para cambiar a la siguiente promoción
  const nextPromo = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentVariant(prev => (prev + 1) % variants.length);
      setTimeout(() => {
        setIsTransitioning(false);
      }, 500);
    }
  };

  // Función para cambiar a la promoción anterior
  const prevPromo = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentVariant(prev => (prev - 1 + variants.length) % variants.length);
      setTimeout(() => {
        setIsTransitioning(false);
      }, 500);
    }
  };

  // Auto cambio cada 5 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      nextPromo();
    }, 5000);

    return () => clearInterval(interval);
  }, [isTransitioning]); // Dependencia para reiniciar el timer si hay interacción

  // Manejo de gestos táctiles
  const handleTouchStart = (e) => {
    touchStartRef.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndRef.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (!touchStartRef.current || !touchEndRef.current) return;
    
    const distance = touchStartRef.current - touchEndRef.current;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      nextPromo(); // Swipe izquierda -> siguiente promoción
    }
    if (isRightSwipe) {
      prevPromo(); // Swipe derecha -> promoción anterior
    }

    touchStartRef.current = null;
    touchEndRef.current = null;
  };

  return (
    <Grid item sx={{ 
      flex: 3, 
      position: "relative", 
      overflow: "hidden",
      maxWidth: "100%", // Asegurar que no exceda el ancho del contenedor
      width: "100%"
    }}>
      <Box 
        sx={{ 
          position: "relative",
          height: "100%",
          cursor: "pointer",
          userSelect: "none",
          display: "flex",
          width: `${variants.length * 100}%`,
          transition: isTransitioning ? "transform 0.5s ease-out" : "transform 0.3s ease-out",
          transform: `translateX(-${currentVariant * (100 / variants.length)}%)`,
          willChange: "transform",
          maxWidth: "none", // Permitir que el contenedor interno sea más ancho
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onClick={nextPromo}
      >
        {/* Renderizar todas las promociones de manera continua */}
        {variants.map((variant, index) => (
          <Box
            key={index}
            sx={{
              width: `${100 / variants.length}%`,
              height: "100%",
              p: 4,
              backgroundColor: variant.color,
              position: "relative",
              flexShrink: 0,
              willChange: "auto",
              transform: "translateZ(0)", // Hardware acceleration
              overflow: "hidden", // Prevenir desbordamiento
              boxSizing: "border-box", // Incluir padding en el ancho
            }}
          >
            <Box
              sx={{
                background: "#fff",
                borderRadius: "0px 0px 0px 50px",
                width: "400px",
                height: "80px",
                position: "absolute",
                right: 0,
                bottom: "19.6rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={variant.logoImage}
                alt={variant.logoImageAlt}
                style={{ width: variant.widthLogo }}
              />
            </Box>
            <Typography
              variant="h4"
              sx={{ mb: 2, color: "#fff", ml: 5 }}
            >
              {variant.day}
            </Typography>
            <Grid container spacing={2} sx={{ overflow: "hidden" }}>
              <Grid item xs={5}>
                <img
                  src={variant.mainImage}
                  alt={variant.mainImageAlt}
                  style={{ 
                    width: variant.widthImg, 
                    marginTop: "1rem",
                    marginLeft: "4rem",
                    maxWidth: "calc(100% - 5rem)"
                  }}
                />
              </Grid>
              <Grid item xs={7} sx={{ overflow: "hidden" }}>
                <img
                  src={variant.promoImage}
                  alt={variant.promoImageAlt}
                  style={{ 
                    width: "100%", 
                    marginLeft: "-2rem", 
                    maxWidth: "calc(100% + 4rem)"
                  }}
                />
              </Grid>
              <Grid item xs={12} sx={{ mt: -3, overflow: "hidden" }}>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: 30,
                    fontWeight: "bold",
                    marginLeft: variant.ml,
                    whiteSpace: "nowrap", // Evitar salto de línea
                    overflow: "hidden", // Ocultar desbordamiento
                    textOverflow: "ellipsis", // Puntos suspensivos si es necesario
                  }}
                >
                  {variant.promoText}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        ))}

        
        {/* Indicadores de promoción */}
        <Box
          sx={{
            position: "absolute",
            bottom: 20,
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            gap: 1,
            zIndex: 100,
          }}
        >
          {variants.map((_, index) => (
            <Box
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                if (!isTransitioning && index !== currentVariant) {
                  setIsTransitioning(true);
                  setCurrentVariant(index);
                  setTimeout(() => {
                    setIsTransitioning(false);
                  }, 500);
                }
              }}
              sx={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                backgroundColor: currentVariant === index ? "#fff" : "rgba(255,255,255,0.4)",
                cursor: "pointer",
                transition: "background-color 0.2s ease",
                "&:hover": {
                  backgroundColor: "#fff",
                },
              }}
            />
          ))}
        </Box>
      </Box>
    </Grid>
  );
};
